import React, { useState } from 'react'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'

import { strCol } from '@integec/grid-tools/lib/cols'
import {
  wind2AllContribCond,
  wind2AllContribCondDelete,
  wind2AllContribCondSave,
} from 'api/pgads'

const title = 'Wind Contribute Op. Condition'

const Wind2ContributeCondition = _ => {
  const [insertEvent, setInsertEvent] = useState(false)
  const InsertComp = _ => <div />

  return (
    <CommonScreen
      title={title}
      header={Wind2ContributingOpConditionHeaders}
      saveTask={wind2AllContribCondSave}
      retrieveTask={wind2AllContribCond}
      deleteTask={wind2AllContribCondDelete}
      autoRetrieve
      widthOffset={50}
      insertComp={insertEvent && InsertComp}
      insertCompHeight={150}
      onInsertEvent={_ => setInsertEvent(false)}
      autoFixColByKey={false}
      headerRowHeight={30}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Wind2ContributeCondition)

const Wind2ContributingOpConditionHeaders = [
  strCol({
    ident: 'contOpCondition',
    display: 'Cont Op. Condition',
    isKey: true,
    width: 500,
    ellipsis: true,
    alignment: 'left',
  }),
  strCol({ ident: 'contOpCode', display: 'Cont Op. Code', isKey: true }),
  strCol({
    ident: 'contOpDescription',
    display: 'Cont Op. Description',
    isFiltered: true,
    width: 800,
    ellipsis: true,
    alignment: 'left',
  }),
]
